import axios from 'axios';
import {getField, updateField} from 'vuex-map-fields';
// import { downloadFile } from "@/helpers/helpers";

const getDefaultState = () => {
    return {
        orders: {
            items: [],
            from: 0,
            to: 0,
            total: 0
        },
    }
}

export const state = getDefaultState();

export const getters = {
    getField
}

export const actions = {
    async fetchOrder({commit}, pagination) {
        const response = await axios.post(`/fastmarket/admin/order?page=${pagination.currentPage}`, {...pagination});
        commit('SET_ORDERS', response.data)
    },
    async fetchById({commit}, Id) {
        const response = await axios.get(`/fastmarket/admin/order/${Id}/show`);
        commit('SET_ORDER', response.data.data);
    },
    async pay({commit}, Id) {
        const response = await axios.get(`/fastmarket/admin/order/${Id}/pay`);
        commit('SET_ORDER', response.data.data);
    },
    async updateWholesaler({commit}, data){
        const response = await axios.put(`/fastmarket/admin/wholesaler`, data);
        commit('SET_WHOLESALER', response.data.user);
        return response.data.result
    },
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    async actionInvoice({commit}, data) {
        const response = await axios.post(`hub/order/actionInvoice`, data);
        return response.data;
    },

}

export const mutations = {
    updateField,
    SET_ORDERS: (state, result) => {
        state.orders = {
            items: [],
            from: result.meta.from,
            to: result.meta.to,
            total: result.meta.total
        }
        let objectArray = Object.entries(result.data);

        objectArray.forEach(([key, value]) => {
            key;
            state.orders.items.push(value)
        })
    },
    SET_ORDER(state, result) {
        state.order = result
    }
}